import type { Question } from "@/types/assessment.types";
import type { Option } from "@shared/types";

export function resolveOptions(
  question: Question,
  answers: Record<string, unknown>,
  questions: Question[],
  kind: 'radio' | 'checkbox'
): Option[] {
  const baseOptions: Option[] = (question.typeOptions as any)?.[kind]?.options || [];
  const dynamicConfig = (question as any).dynamicConfig as
    | { optionsBasedOn?: string; optionsMapping?: Record<string, Option[]> }
    | undefined;

  if (!dynamicConfig?.optionsBasedOn || !dynamicConfig?.optionsMapping) return baseOptions;

  // Build answersByQuestionId map to support both id and legacy index keys
  const answersByQuestionId: Record<string, unknown> = {};
  Object.entries(answers).forEach(([key, value]) => {
    const matchingQuestion = questions.find((q) => (q as any).id === key);
    if (matchingQuestion) answersByQuestionId[key] = value;
  });
  questions.forEach((q, idx) => {
    const key = `question-${idx}-${q.type}`;
    const qid = (q as any).id;
    if (answers[key] !== undefined && qid && !answersByQuestionId[qid]) {
      answersByQuestionId[qid] = answers[key];
    }
  });

  const dependentValue =
    (answersByQuestionId as any)[dynamicConfig.optionsBasedOn] ||
    (answers as any)[dynamicConfig.optionsBasedOn];
  if (dependentValue && typeof dependentValue === 'string') {
    const mapped = dynamicConfig.optionsMapping?.[dependentValue];
    if (mapped?.length) return mapped as Option[];
  }
  return baseOptions;
}
